import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

import { THEME_COOKIE, THEME_DARK_MODE, THEME_DEFAULT, THEME_LIST } from '@finder/features/theme-engine/theme-engine.constants';
import { FinderThemeService } from '@finder/shared/services/theme-service/finder-theme.service';

@Injectable({
    providedIn: 'root',
})
export class ThemeEngineService {
    selectedValue: string;

    constructor(
        private cookieService: CookieService,
        private themeService: FinderThemeService,
        @Inject(DOCUMENT) private document: Document,
    ) {}

    changeTheme(e?) {
        // Set default value
        if (!e) {
            e = this.cookieService.get(THEME_COOKIE) || THEME_DEFAULT;
        }

        // Set value of drop down
        this.selectedValue = THEME_LIST.find(theme =>
            theme.toUpperCase() === e.toUpperCase()
        );

        // Prep the value for cookie storage and themifying
        const cookieVal = e.replace(' ', '-').toLowerCase();

        // Enable theme
        this.enableTheme(cookieVal);

        // Iterate the dark mode map keys and reduce to an array of the values
        const darkClasses = Object.keys(THEME_DARK_MODE).reduce((acc, key) => {
            // Add the value to the accumulator
            acc.push(THEME_DARK_MODE[key]);

            return acc;
        }, []);

        // Remove "dark mode" classes
        this.document.body.classList.remove(...darkClasses);

        // Check for a match and add the dark mode class
        if (Object.keys(THEME_DARK_MODE).includes(cookieVal)) {
            this.document.body.classList.add(THEME_DARK_MODE[cookieVal]);
        }

        // Set cookie for reload
        this.cookieService.set(THEME_COOKIE, cookieVal);
    }

    enableTheme(theme: string) {
        this.themeService.setCurrentTheme(theme);
    }
}
